import { render, staticRenderFns } from "./DesignerBeforePublishModal.vue?vue&type=template&id=8f626c9c&scoped=true&"
import script from "./DesignerBeforePublishModal.vue?vue&type=script&lang=js&"
export * from "./DesignerBeforePublishModal.vue?vue&type=script&lang=js&"
import style0 from "./DesignerBeforePublishModal.vue?vue&type=style&index=0&id=8f626c9c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f626c9c",
  null
  
)

export default component.exports